import { createSlice } from '@reduxjs/toolkit';
import { getTenantToCourse } from './tenantToCourseAction';

export const tenantToCourseSlice = createSlice({
  name: 'tenantToCourse',
  initialState: {
    loading: false,
    data: {},
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTenantToCourse.pending, (state) => {
      state.loading = true;
      state.data = {};
    });
    builder.addCase(getTenantToCourse.fulfilled, (state, { payload }) => {      
      state.loading = false;
      state.data = payload;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(getTenantToCourse.rejected, (state, action) => {
      state.loading = false;
      state.data = {};
      state.error = action.payload || 'An error occurred';
    });
  },
});
